import React from 'react';
import { exportToExcel } from './utils/exportToExcel';
import { exportToCsv } from './utils/exportToCsv';
import { Download, SystemUpdateAlt } from '@mui/icons-material';
import { Header } from '../Table';
import { LightTooltip } from '../WhiteTooltip';
import { IconButton, Typography } from '@mui/material';

interface DataExporterProps {
  buttonText?: string;
  buttonColor?: 'primary' | 'secondary' | 'warning' | 'success' | 'transparent';
  data: any[];
  fileName?: string;
  fileType: 'csv' | 'xlsx';
  headers: Header[];
  complete?: boolean;
  searchData?: any;
  setLoading?: any;
}

const DataExporter: React.FC<DataExporterProps> = (props) => {
  const {
    data,
    fileName,
    fileType,
    headers,
    complete,
    searchData,
    setLoading,
  } = props;

  const exportData = () => {
    switch (fileType) {
      case 'csv':
        exportToCsv(data, headers, fileName);
        break;
      case 'xlsx':
        exportToExcel(data, headers, fileName);
        break;
      default:
        break;
    }
  };

  const exportCompleteData = async () => {
    setLoading(true);
    const rows: any[] = [];
    const response = await searchData({
      exportComplete: true,
    });
    rows.push(...response.data);
    switch (fileType) {
      case 'csv':
        exportToCsv(rows, headers, fileName);
        break;
      case 'xlsx':
        exportToExcel(rows, headers, fileName);
        break;
      default:
        break;
    }
    setLoading(false);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
      {complete ? (
        <LightTooltip
          title={
            <Typography padding={1}>Exportar todas las páginas</Typography>
          }
        >
          <IconButton onClick={() => exportCompleteData()}>
            <SystemUpdateAlt fontSize="medium" />
          </IconButton>
        </LightTooltip>
      ) : (
        <LightTooltip
          title={<Typography padding={1}>Exportar página actual</Typography>}
        >
          <IconButton onClick={() => exportData()}>
            <Download fontSize="medium" />
          </IconButton>
        </LightTooltip>
      )}
      {/* <Typography style={{ marginLeft: '4px' }} onClick={() => exportData()}>
        {buttonText ?? 'Exportar'}
      </Typography> */}
    </div>
  );
};

export default DataExporter;
